var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartSideLeft(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 557,
    viewBox: "0 0 343 557",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M343 244.628L343 134.232L208.458 -1.17621e-05L-1.84249e-05 210.757L343 557L343 446.185L110.458 210.757L208.873 110.815L343 244.628Z",
    fill: "#F15924"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartSideLeft);
export default __webpack_public_path__ + "static/media/heart-side-left.1ebefd83d01401e5cf24cae0ca2ad78b.svg";
export { ForwardRef as ReactComponent };